
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	// faTwitter,
	faGithub,
	faLinkedin,
	faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import Logo from "../components/common/logo";
import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import SEOHead from "../components/common/SEOHead";
import Article from "../components/homepage/article";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import { useArticles } from '../contexts/ArticlesContext';

import "./styles/homepage.css";

function createMarkup(htmlString) {
	return {__html: htmlString};
  }

const Homepage = () => {
	const [stayLogo, setStayLogo] = useState(false);
	const [logoSize, setLogoSize] = useState(80);
	const [oldLogoSize, setOldLogoSize] = useState(80);
	const { articles, fetchArticles } = useArticles();

	useEffect(() => {
		if (articles.length === 0) {
			fetchArticles();
		}
	}, [articles, fetchArticles]);


	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			let scroll = Math.round(window.pageYOffset, 2);

			let newLogoSize = 80 - (scroll * 4) / 10;

			if (newLogoSize < oldLogoSize) {
				if (newLogoSize > 40) {
					setLogoSize(newLogoSize);
					setOldLogoSize(newLogoSize);
					setStayLogo(false);
				} else {
					setStayLogo(true);
				}
			} else {
				setLogoSize(newLogoSize);
				setStayLogo(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [logoSize, oldLogoSize]);

	const currentSEO = SEO.find((item) => item.page === "home");

	const logoStyle = {
		display: "flex",
		position: stayLogo ? "fixed" : "relative",
		top: stayLogo ? "3vh" : "auto",
		zIndex: 999,
		border: stayLogo ? "1px solid white" : "none",
		borderRadius: stayLogo ? "50%" : "none",
		boxShadow: stayLogo ? "0px 4px 10px rgba(0, 0, 0, 0.25)" : "none",
	};

	return (
		<React.Fragment>
			<SEOHead
				description={currentSEO.description}
				keywords={currentSEO.keywords}
				path="/"
				jsonLd={[
					{
						"@context": "https://schema.org",
						"@type": "WebPage",
						"@id": "https://www.northwestwind.org/#homepage",
						url: "https://www.northwestwind.org/",
						name: "North West Wind",
						description: currentSEO.description,
						isPartOf: { "@id": "https://www.northwestwind.org/#website" },
						about: { "@id": "https://www.northwestwind.org/#person" },
					},
				]}
			/>

			<div className="page-content">
				<NavBar active="home" />
				<div className="content-wrapper">
					<div className="homepage-logo-container">
						<div style={logoStyle}>
							<Logo width={logoSize} link={false} />
						</div>
					</div>

					<div className="homepage-container">
						<div className="homepage-first-area">
							<div className="homepage-first-area-left-side">
								<div className="title homepage-title">
									{INFO.homepage.title}
								</div>

								<div
								className="subtitle homepage-subtitle"
								dangerouslySetInnerHTML={createMarkup(INFO.homepage.description)}
								/>

								<div className="homepage-socials">
									<a
										href={INFO.socials.github}
										target="_blank"
										rel="noreferrer"
									>
										<FontAwesomeIcon
											icon={faGithub}
											className="homepage-social-icon"
										/>
									</a>
									<a
										href={INFO.socials.linkedin}
										target="_blank"
										rel="noreferrer"
									>
										<FontAwesomeIcon
											icon={faLinkedin}
											className="homepage-social-icon"
										/>
									</a>
									<a
										href={INFO.socials.instagram}
										target="_blank"
										rel="noreferrer"
									>
										<FontAwesomeIcon
											icon={faInstagram}
											className="homepage-social-icon"
										/>
									</a>
									<a
										href={`mailto:${INFO.main.email}`}
										target="_blank"
										rel="noreferrer"
									>
										<FontAwesomeIcon
											icon={faMailBulk}
											className="homepage-social-icon"
										/>
									</a>
								</div>
							</div>

							<div className="homepage-first-area-right-side" aria-hidden="true">
								<div className="homepage-proof-panel">
									<div className="homepage-proof-image-wrap">
										<img
											src="about.jpg"
											alt=""
											className="homepage-proof-image"
										/>
									</div>
									<div className="homepage-proof-brand">
										<img src="swapstamp.svg" alt="" />
									</div>
									<div className="homepage-proof-stack">
										<img src="projects_logo/terraform.png" alt="" />
										<img src="projects_logo/cognito.png" alt="" />
										<img src="projects_logo/awslambda.png" alt="" />
										<img src="projects_logo/wallet.png" alt="" />
									</div>
								</div>
							</div>
						</div>
						<div className="homepage-bottom-section" dangerouslySetInnerHTML={createMarkup(INFO.homepage.description_add)}>
 						 </div>

						<div className="homepage-section-heading">Swapstamp</div>
						<div className="homepage-brand-link">
							<Link to="/swapstamp">
								<div className="homepage-brand-link-icon">
									<img
										src="swapstamp.svg"
										alt="Swapstamp"
										className="homepage-brand-link-image"
									/>
								</div>
								<div className="homepage-brand-link-text">
									Swapstamp Digital Loyalty Programs
								</div>
							</Link>
						</div>
						<div className="homepage-projects">
							<AllProjects />
						</div>

						<div className="homepage-after-title">
						<div className="homepage-section-heading">Articles</div>
						<div className="homepage-articles-section">
							{articles.slice(0, 3).map((article) => (
								<Article
									key={article.articleId}
									date={article.date}
									title={article.title}
									description={article.description}
									link={`/article/${article.articleId}`}
								/>
							))}
						</div>
						</div>

						<div className="page-footer">
							<Footer />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Homepage;
